import { createFileRoute } from '@tanstack/react-router'
import EditPage from '../../../../../../containers/Datasets/EditPage'
import { datasetDetailSearchSchema } from '../search-schemas'

export const Route = createFileRoute(
  '/_authenticated/project/$projectId/datasets/$datasetId/'
)({
  validateSearch: datasetDetailSearchSchema,
  component: EditPage
})
